/* eslint-disable max-len */
import React, { Fragment } from 'react'
import Pagination from '../../../../../components/Pagination';
import { formatAdjustedDate } from '../../../../../CommonMethods/formatDate';
import { useNavigate } from 'react-router-dom';

const Table = ({GRNList,
    searchParams, 
    setSearchParams,
    handleOnClickSort,
    sortValue,
    setPageLoading, startDate, endDate,
    GRNListCount}) => {
    const urlParams = new URLSearchParams(window.location.search);

    const branchUrl = urlParams.get("sort");
    const navigate = useNavigate('')
    /**
     * The function `handleOnClickPageNumber` updates the search parameters with a new page number and sets
     * the page loading state to true.
     */
    const handleOnClickPageNumber = (pageNum) => {
        setPageLoading(true);
        const params = Object.fromEntries(searchParams) 
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }
    const handleSort = (key) => {
        if(sortValue === '') handleOnClickSort('sort', `${key}+asc`)
        else {
            if(sortValue.includes(key)) handleOnClickSort('sort', `${key}+${sortValue.includes('+desc') ? 'asc' : 'desc'}`)
            else handleOnClickSort('sort', `${key}+asc`)
        }
    }

    const noSearchOrFilter = searchParams.get('search') === null && searchParams.get('filter') === null;

    return(
        <div class="-mx-1">
            <div className='text-center absolute w-full'>GRN Date from <span className="font-semibold">{searchParams?.get('start_date') === null ?  formatAdjustedDate(startDate) : formatAdjustedDate(searchParams?.get('start_date'))}</span> to <span className="font-semibold">{searchParams?.get('end_date') === null ?  formatAdjustedDate(endDate, true) : formatAdjustedDate(searchParams?.get('end_date'))}</span></div>
            <div className={`flex mb-3 overflow-auto pb-[6px] scroll-bar px-1 topHeading`} id="search-result">
                <table aria-label="Outside Table" class="w-full " id="admin-table">
                    <thead>
                        <tr>
                            <th id="GRN Date" class="w-[13%]" onClick={() => {handleSort('grn_date')}}>
                                <span >GRN Date
                                    <button type="button" class="pl-1.5 sortedIcon">
                                        <img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "grn_date" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon"/>
                                    </button>
                                </span>
                            </th>
                            <th id="GRN Number" class="w-[11%]" onClick={() => {handleSort('grn_number')}}>
                                <span >GRN #
                                    <button type="button" class="pl-1.5 sortedIcon">
                                        <img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "grn_number" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon"/>
                                    </button>
                                </span>
                            </th>
                            <th class="w-[11%]">
                                <span class="flex items-center justify-end">Amount
                                </span>
                            </th>
                            <th class="w-[12%]">
                                <span >PO #
                                </span>
                            </th>
                            <th id="Vendor Name" class="w-[14%]" onClick={() => {handleSort('vendor_name')}}>
                                <span >Vendor Name
                                    <button type="button" class="pl-1.5 sortedIcon">
                                        <img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "vendor_name" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon"/>
                                    </button>
                                </span>
                            </th>
                            <th class="w-[16%]">
                                <span class="flex items-center justify-start text-left">Vendor Invoice #
                                </span>
                            </th>
                            <th class="w-[13%]">
                                <span class="flex items-center justify-end text-right">Pending Amt
                                </span>
                            </th>
                            <th class="w-[10%]">
                                <span class="flex items-center justify-center">Action
                                </span>
                            </th>
                        </tr>
                        <tr aria-colspan="7" class="h-1"></tr>
                    </thead>
                    <tbody >
                        {GRNList?.map((grn) => (
                            <>
                                <tr id="list-items" aria-colspan="7" class="relative h-0.5 z-[-10]"></tr>
                                <tr class="group cursor-pointer" title="View GRN Details" onClick={()=>{
                                    navigate(`/inventory-master/grn-entry/view-grn-entry/${encodeURIComponent(grn?.id)}?${searchParams.toString()}`)
                                }}>
                                    <td class="text-start">{formatAdjustedDate(grn?.grn_date) || '-'}</td>
                                    <td class="text-start ">{grn?.grn_number || '-'}</td>

                                    <td class="text-end">{parseFloat(grn?.grn_total).toFixed(2) || '-'}</td>
                                    <td class="text-start capitalize ">{grn?.po_number || '-'}</td>

                                    <td class="text-start">{grn?.vendor_name || '-'}</td>
                                    <td class="text-start">{grn?.vendor_invoice || '-'}</td>
                                    <td class="text-end">{grn?.pending_amount || '0.00'}</td>
                                    <td class="h-full pl-3 pr-6 py-2 text-f2 text-[#031624] cursor-pointer text-start   ">
                                        <div className='flex justify-center items-center'>
                                            <button id='view_grn_details_btn' className='list-actn-btn'>
                                                View
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </>))}
                    </tbody>
                    {GRNListCount === 0 && (
                        <tbody>
                            <tr>
                                <td style={{ 'line-height': '100px' }} colspan="7" className="no-records-message" id='no-matching-result'>
                                    {noSearchOrFilter ? `No GRN Entries added yet.` : 'No matching records found.'}
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div> 
            {GRNListCount > 10 &&  <Pagination
                TotalCount={GRNListCount}
                totalPageNumber={Math?.ceil(GRNListCount / 10)}
                selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                handleOnClickPageNumber={handleOnClickPageNumber}
            />}
        </div>
    )
}
export default Table;   